module.exports = __webpack_public_path__ + "img/rank-cup.976d0f21.png";